<div class="loading">
  <!-- <p>loading is working</p> -->
  <div class="overlay"></div>
  <!-- <img src="https://media1.giphy.com/media/v1.Y2lkPTc5MGI3NjExbzI3MThmc3FmbTZheXZpajQ2M3FweTE2OXk5cDhlZmY2MHdsOTc1NSZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/PiQNvGsBwIRqwSoCm5/giphy.gif" alt="Đang xử lý..."> -->
  <div class="wrapper">
    <img src="../../../assets/images/loading.gif" alt="Đang xử lý..." style="max-width: 150px;">
    <p class="text">Đang xử lý...</p>
  </div>
  <!-- <mat-spinner></mat-spinner> -->
</div>